import * as XLSX from 'xlsx-js-style';

/** Use to copy object or array completely */
export const getCopy = <T>(orig: T): T => JSON.parse(JSON.stringify(orig));

/** Use to copy sheet completely */
export const getSheetCopy = (sheet: XLSX.WorkSheet) => getCopy<XLSX.WorkSheet>(sheet);
